import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Search } from 'lucide-react';
import { Input } from "../components/ui/input";

const FAQJP = () => {
  useEffect(() => {
    document.title = 'Internjin | よくある質問';
  }, []);

  const faqs = [
    {
      category: "全般",
      items: [
        { q: "Internjinは人材紹介会社ですか？", a: "いいえ。Internjinはインターンシップに特化したマッチングプラットフォームであり、教育的支援要素を含んでいます。目的はトレーニングと異文化交流であり、永続的な配置ではありません。" },
        { q: "Internjinはいつからありますか？", a: "Internjinは立ち上げフェーズのスタートアップで、日本でのインターンシップ経験を持つ2人のフランス人学生によって設立されました。Sushi Tech Tokyoにて最初の日本のパートナーを探しています。" },
        { q: "フランスの機関から支援を受けていますか？", a: "Internjinはフランスの高等教育機関と連携しており、機関とのパートナーシップを積極的に求めています。このモデルは、インターンシップに関するフランスの法的要件に完全に準拠しています。" }
      ]
    },
    {
      category: "学生",
      items: [
        { q: "どのようなレベルの学生ですか？", a: "学生はフランスのビジネススクール、エンジニアリングスクール、大学、専門機関から来ており、学士レベル（3年制）から修士レベル（5年制）まで、テック、デザイン、マーケティング、金融、HRなど多岐にわたります。" },
        { q: "彼らは日本語を話せますか？", a: "話せる学生もいますが、必須ではありません。英語で業務可能な学生も選ばれています。言語基準で応募をフィルタリングでき、すべての学生が出発前に日本に関する文化的準備を受けます。" },
        { q: "学生は一人で来日しますか？", a: "はい。学生は自身の渡航と宿泊の手配を行いますが、事前にInternjinが支援します。Internjinはまた、学生の歓迎と統合を促進するために、企業を地域のリソースとつなげることもできます。" },
        { q: "インターンシップがうまくいかない場合は？", a: "Internjinは仲介役として機能し、双方にとって満足のいく解決策を見つけるために迅速に介入します。極端な場合には、契約条件に従ってインターンシップを早期に終了することも可能です。" },
        { q: "フランス人学生は日本の職場文化にどう対応しますか？", a: "フランス人学生は率直で積極的な傾向があり、日本の規範とは異なる場合があります。すべての学生は、コミュニケーションスタイル、ヒエラルキー、時間厳守、ビジネスマナーをカバーする異文化準備を受けます。Internjinはインターンシップ期間中、双方をサポートするために利用可能です。" },
        { q: "学生が日本で事故に遭ったり病気になったら？", a: "学生は出発前に個人の健康保険と旅行保険を手配する必要があります。企業は個人の健康保険に対して責任を負いません。労働災害はインターンシップ契約に記載された責任に従い、Internjinは双方に助言を提供できます。" },
        { q: "インターンシップ後に学生を正社員として採用できますか？", a: "もちろんです。実際にそのようなケースもあります。双方が関心を持っている場合、企業は配置終了時にフルタイムのポジションをオファーできます。Internjinはこの結果を全面的にサポートします。" }
      ]
    },
    {
      category: "ビジネスモデル",
      items: [
        { q: "企業にとってのコストは？", a: "日本の法律では学生に給与を支払う法的義務はありませんが、優秀な候補者を引き付けるために報酬を提供することを強く推奨します。マッチングとフォローアップのためにInternjinへのサービス料も発生します。詳細な料金表は初回ミーティング時に提供されます。" },
        { q: "学生は企業の従業員ですか？", a: "いいえ。学生はインターンシップ契約に基づいており、雇用契約は不要です。インターンシップ契約書が必要な唯一の法的文書です。" },
        { q: "インターンシップの期間は？", a: "インターンシップは、学生の都合、企業のニーズ、プロジェクトの範囲に応じて、2ヶ月から1年の範囲です。" }
      ]
    },
    {
      category: "手続き",
      items: [
        { q: "企業が行うべきステップは？", a: "ニーズと希望するプロファイルを定義し、インターンシップ契約に署名し、社内メンターを指名し、学生を歓迎します。Internjinは候補者の選定、文書管理、継続的なサポートを担当します。" },
        { q: "マッチングプロセスにはどのくらいかかりますか？", a: "選考とマッチングは、オファーが掲載された瞬間から通常2〜4週間かかります。Internjinは、ビザのタイムラインと学術スケジュールを考慮して、希望する開始日の少なくとも6〜8週間前に計画することを推奨します。" },
        { q: "うまくいけばインターンシップを延長または更新できますか？", a: "はい。学生の学術的枠組みの範囲内であり、双方が同意する限り可能です。延長は、元のインターンシップ契約の修正を通じて正式に行う必要があり、Internjinが対応します。" },
        { q: "企業はフランス語を話す必要がありますか？", a: "いいえ。Internjinはバイリンガルの仲介を提供し、すべての文書は英語または日本語で提供されます。" },
        { q: "Internjinとのパートナーシップを開始するには？", a: "コミットメントなしのディスカバリーコールをスケジュールするためにご連絡ください。チームは企業のニーズに合わせた提案を作成します。" }
      ]
    }
  ];

  return (
    <Layout>
      <section className="bg-slate-900 text-white py-20">
        <div className="container mx-auto px-4 md:px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">ヘルプセンター</h1>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto mb-8">
            Internjin、採用プロセス、学生に関するよくある質問にお答えします。
          </p>
          <div className="max-w-xl mx-auto relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
            <Input 
              placeholder="回答を検索..." 
              className="pl-10 h-12 bg-white/10 border-slate-700 text-white placeholder:text-slate-400 focus-visible:ring-red-500 rounded-full" 
            />
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl">
          <Tabs defaultValue="全般" className="space-y-8">
            <div className="flex justify-center overflow-x-auto pb-4">
              <TabsList className="bg-white p-1 rounded-full border border-slate-200 shadow-sm h-auto inline-flex">
                {faqs.map((cat) => (
                  <TabsTrigger 
                    key={cat.category} 
                    value={cat.category}
                    className="rounded-full px-6 py-3 data-[state=active]:bg-slate-900 data-[state=active]:text-white text-slate-600 font-medium transition-all"
                  >
                    {cat.category}
                  </TabsTrigger>
                ))}
              </TabsList>
            </div>

            {faqs.map((cat) => (
              <TabsContent key={cat.category} value={cat.category} className="space-y-6 animate-in fade-in-50 slide-in-from-bottom-4 duration-500">
                <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
                  <div className="p-6 border-b border-slate-100 bg-slate-50/50">
                    <h2 className="text-2xl font-bold text-slate-900">{cat.category}について</h2>
                  </div>
                  <div className="p-6">
                    <Accordion type="single" collapsible className="w-full space-y-4">
                      {cat.items.map((item, j) => (
                        <AccordionItem key={j} value={`item-${j}`} className="border rounded-lg px-4 data-[state=open]:bg-slate-50 transition-colors border-slate-200">
                          <AccordionTrigger className="text-left font-semibold text-slate-800 hover:text-red-600 hover:no-underline py-4">
                            {item.q}
                          </AccordionTrigger>
                          <AccordionContent className="text-slate-600 leading-relaxed pb-4">
                            {item.a}
                          </AccordionContent>
                        </AccordionItem>
                      ))}
                    </Accordion>
                  </div>
                </div>
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </section>
    </Layout>
  );
};

export default FAQJP;
